module.exports = __webpack_public_path__ + "static/media/faqImage5.c7eb2edc.svg";